export default "<!-- <ngx-loading-bar [includeSpinner]=\"false\"></ngx-loading-bar> -->\n<router-outlet></router-outlet>\n"